import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=6dff2d2e&scoped=true&"
import script from "./topBanner.vue?vue&type=script&lang=ts&"
export * from "./topBanner.vue?vue&type=script&lang=ts&"
import style0 from "./topBanner.vue?vue&type=style&index=0&id=6dff2d2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff2d2e",
  null
  
)

export default component.exports